.base {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-x2);
  border: 0;
  cursor: pointer;
  text-decoration: none;
  transition:
    transform var(--motion-fast) var(--ease),
    background-color var(--motion-fast) var(--ease);
}

.base:active:not(:disabled) {
  transform: scale(var(--press-scale));
}

.base:disabled,
.base[aria-disabled='true'] {
  cursor: default;
  opacity: 0.5;
}

.cta {
  width: 100%;
  min-height: var(--size-cta);
  padding: 0 var(--space-x6);
  border-radius: calc(var(--size-cta) / 2);
  background: var(--c-cta);
  color: var(--c-on-cta);
  font: var(--text-button);
}

.cta:hover:not(:disabled) {
  background: var(--c-cta-hover);
}

.ink {
  width: 100%;
  min-height: var(--size-cta);
  padding: 0 var(--space-x6);
  border-radius: calc(var(--size-cta) / 2);
  background: var(--c-ink);
  color: var(--c-on-ink);
  font: var(--text-button);
}

.secondary,
.danger {
  min-height: var(--size-button);
  padding: 0 var(--space-x5);
  border-radius: var(--radius-chip);
  background: var(--c-surface);
  color: var(--c-text);
  font: var(--text-label);
}

.danger {
  color: var(--c-danger);
}

.text {
  min-height: var(--size-control);
  padding: 0 var(--space-x3);
  background: transparent;
  color: var(--c-accent);
  font: var(--text-label);
}

.block {
  width: 100%;
}

.icon {
  width: var(--size-control);
  height: var(--size-control);
  flex: none;
  border: 0;
  border-radius: var(--radius-full);
  background: var(--c-surface);
  color: var(--c-text);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
